import React, { useState, useEffect } from 'react';
import { fireauth } from '../config/firebase.config';
import Login from './Login';
import Settings from './Settings';


const Auth = () => {


    const [user, setUser] = useState(null)
    useEffect(() => {
        fireauth.onAuthStateChanged(userAuth => {
            setUser(userAuth)
        })
    }, []);

    return (<>{user ? <Settings></Settings> : <Login></Login>}</>)

}
export default Auth;